import type { ReactNode } from 'react'
import type { SubscriptionTier } from '../context/AuthContext'
import { useAuth } from '../context/AuthContext'

export function TierGate({
  tiers,
  children,
}: {
  tiers: SubscriptionTier[]
  children: ReactNode
}) {
  const { isLoading, viewerContext } = useAuth()

  // While auth is loading, show nothing to avoid flash of wrong content
  if (isLoading || !viewerContext) return null

  // Tier mismatch: hide content without redirecting.
  // Tests and denied-route contracts expect tier_hidden_or_null behavior.
  if (!tiers.includes(viewerContext.tier)) return null

  return <>{children}</>
}
